module.exports = __webpack_public_path__ + "img/ky.144850af.svg";